import axios from "axios";
import { IAgeGoup } from "../../../Models/AgeGroups/IAgeGroup";
import { IResult } from "../../../Models/Result/IResult";
import { IRoom } from "../../../Models/Rooms/IRoom";
import { formatUrl, handleError } from "../ApiHelpers";
import { IRoomApi } from "./IRoomApi";

export class RoomApi implements IRoomApi {

    private backendUrl: string;

    constructor(url: string) {
        this.backendUrl = url;
    }

    async getRooms(filter: string): Promise<IResult<IRoom[]>> {
        try {
            const url = formatUrl(this.backendUrl, `/api/Rooms/GetRooms?filter=${filter}`);
            const response = await axios.get(url);
            return response.data as IResult<IRoom[]>;
        }
        catch (error) {
            return handleError(error, "getRooms");
        }
    }

    async getDistrict(): Promise<IResult<string[]>> {

        try {
            const url = formatUrl(this.backendUrl, `/api/Rooms/GetDistrict`);
            const response = await axios.get(url);
            return response.data as IResult<string[]>;
        }
        catch (error) {
            return handleError(error, "getDistrict");
        }
    }

    async createRoom(room: IRoom): Promise<IResult<number>> {
        try {
            const url = formatUrl(this.backendUrl, `/api/Rooms/CreateRoom`);
            const response = await axios.post(url, room);
            return response.data as IResult<number>;
        }
        catch (error) {
            return handleError(error, "createRoom");
        }
    }

    async updateRoom(room: IRoom): Promise<IResult<string>> {
        try {
            const url = formatUrl(this.backendUrl, `/api/Rooms/UpdateRoom/${room.id}`);
            const response = await axios.put(url, room);
            return response.data as IResult<string>;
        }
        catch (error) {
            return handleError(error, "updateRoom");
        }
    }

    async deleteRoom(id: number): Promise<IResult<string>> {
        try {
            const url = formatUrl(this.backendUrl, `/api/Rooms/DeleteRoom/${id}`);
            const response = await axios.delete(url);
            return response.data as IResult<string>;
        }
        catch (error) {
            return handleError(error, "deleteRoom");
        } 
    }

   

     

}